import { useI18n } from "@/context/I18nContext";

export function OnuPicker({ form, setForm, onuList, fetchOnuLanMac, lanMacBusy }) {
  const { t } = useI18n();
  return (
    <div className="col-span-2 border-t border-slate-700 pt-3 mt-1" data-testid="onu-picker">
      <span className="text-xs text-cyan-400 font-semibold uppercase tracking-wide">{t("Przypisz ONU z OLT (SNMP)")}</span>
      <select data-testid="onu-picker-select" defaultValue=""
        onChange={(e) => {
          const o = onuList[Number(e.target.value)];
          if (!o) return;
          setForm((p) => ({ ...p,
            onu_id: o.index,
            onu_mac: o.mac || p.onu_mac,
            onu_sn: o.sn || p.onu_sn,
            power_measurement_dbm: o.rx_dbm != null ? o.rx_dbm : p.power_measurement_dbm,
            onu_tx_dbm: o.tx_dbm != null ? o.tx_dbm : p.onu_tx_dbm,
            onu_temp_c: o.temp_c != null ? o.temp_c : p.onu_temp_c,
            onu_distance_m: o.distance_m != null ? o.distance_m : p.onu_distance_m,
            onu_model: (o.model && o.model !== "unknow") ? o.model : p.onu_model,
            onu_status: o.status || p.onu_status,
          }));
          fetchOnuLanMac(o);
        }}
        className="w-full mt-1.5 bg-slate-900 border border-slate-700 rounded px-2 py-2 text-sm outline-none focus:ring-1 focus:ring-cyan-500">
        <option value="">{onuList.length ? t("— wybierz ONU —") : t("Brak wykrytych ONU (odpytaj OLT w module SNMP)")}</option>
        {onuList.map((o, i) => <option key={i} value={i}>{`${o.port != null ? "PON" + o.port + " · " : ""}#${o.index}${o.mac ? " · " + o.mac : ""}${o.model && o.model !== "unknow" ? " · " + o.model : ""}${o.distance_m != null ? " · " + o.distance_m + " m" : ""}${o.rx_dbm != null ? " · " + o.rx_dbm + " dBm" : ""}${o.status ? " · " + t(o.status) : ""}`}</option>)}
      </select>
      <p className="text-[11px] text-slate-500 mt-1">{t("Lista pochodzi z ostatniego odpytania OLT w module Monitoring SNMP. Jeśli jest pusta: dodaj OLT w module SNMP, kliknij Odpytaj, a najlepiej powiąż to urządzenie z rekordem OLT.")}</p>
      {form.onu_id && (
        <button type="button" data-testid="onu-lanmac-refresh" disabled={lanMacBusy}
          onClick={() => { const o = onuList.find((x) => String(x.index) === String(form.onu_id)); if (o) fetchOnuLanMac(o); }}
          className="mt-2 text-[11px] bg-slate-700 hover:bg-slate-600 disabled:opacity-60 rounded px-2.5 py-1">
          {lanMacBusy ? t("Odczyt MAC z ONU…") : t("Odczytaj MAC z portu Ethernet ONU (SSH)")}
        </button>
      )}
      <div className="mt-3">
        <label className="text-[11px] text-slate-400 block mb-1">{t("MAC routera abonenta (do wiązania na switchu)")}</label>
        <input value={form.router_mac || ""} onChange={(e) => setForm((p) => ({ ...p, router_mac: e.target.value }))} data-testid="client-router-mac"
          placeholder="np. AC:DE:48:00:11:22" className="w-full bg-slate-900 border border-slate-700 rounded px-2 py-2 text-sm outline-none focus:ring-1 focus:ring-cyan-500 font-mono" />
        <p className="text-[11px] text-slate-500 mt-1">{t("Wpisz MAC routera/CPE, gdy abonent nie ma ONU — pozwoli to kliknąć MAC na switchu i przejść wprost do tej karty.")}</p>
      </div>
    </div>
  );
}
